module.exports = __webpack_public_path__ + "assets/94639a72c8a4c867d77a6f50eadeccc5.mp3";